import React from 'react';
import { Card, CardContent } from '../components/ui/card';

const PrivacyPolicyPage = () => {
  return (
    <div className="min-h-screen bg-slate-50">
      {/* Header */}
      <section className="bg-white border-b border-slate-200 py-16">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <h1 className="text-4xl font-bold text-[#0f1f2e] mb-4">Privacy Policy</h1>
          <p className="text-slate-500">Last updated: January 2026</p>
        </div>
      </section>

      {/* Content */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <Card className="bg-white border-slate-200 shadow-sm">
            <CardContent className="p-8 md:p-12 prose prose-slate max-w-none">
              <p className="text-lg text-slate-600 leading-relaxed mb-8">
                IpFunders respects your privacy and is committed to protecting the personal information you share with us. This Privacy Policy explains how we collect, use, and safeguard your information.
              </p>

              <h2 className="text-2xl font-semibold text-[#0f1f2e] mt-10 mb-4">Information We Collect</h2>
              <p className="text-slate-600 leading-relaxed">
                We collect information you voluntarily provide, such as your name, email address, organization, and message content when you submit inquiries through our contact form or via email. We also collect limited technical information, including IP address, browser type, and general usage data through standard analytics tools.
              </p>

              <h2 className="text-2xl font-semibold text-[#0f1f2e] mt-10 mb-4">How We Use Information</h2>
              <p className="text-slate-600 leading-relaxed">
                We use the information we collect to respond to your inquiries, provide requested services, improve website functionality, and maintain security. We do not sell your personal information to third parties.
              </p>

              <h2 className="text-2xl font-semibold text-[#0f1f2e] mt-10 mb-4">Information Sharing</h2>
              <p className="text-slate-600 leading-relaxed">
                We may share your information with service providers who assist with hosting, analytics, and communications, subject to confidentiality obligations. We may also disclose information as required by law or to protect our legal rights.
              </p>

              <h2 className="text-2xl font-semibold text-[#0f1f2e] mt-10 mb-4">Data Retention</h2>
              <p className="text-slate-600 leading-relaxed">
                We retain personal information only as long as necessary to fulfill the purposes for which it was collected or as required by applicable law.
              </p>

              <h2 className="text-2xl font-semibold text-[#0f1f2e] mt-10 mb-4">Your Rights</h2>
              <p className="text-slate-600 leading-relaxed">
                Depending on your jurisdiction, you may have rights to access, correct, or delete your personal information. To exercise these rights, please contact us using the contact methods provided on this website.
              </p>

              <h2 className="text-2xl font-semibold text-[#0f1f2e] mt-10 mb-4">California Privacy Rights</h2>
              <p className="text-slate-600 leading-relaxed">
                California residents may have the right to request access to, correction of, or deletion of personal information collected about them. IpFunders does not sell or share personal information as defined under California law. Requests may be submitted using the contact information provided on this website.
              </p>

              <h2 className="text-2xl font-semibold text-[#0f1f2e] mt-10 mb-4">Data Security</h2>
              <p className="text-slate-600 leading-relaxed">
                We implement reasonable technical and organizational safeguards to protect your information. However, no system is completely secure, and we cannot guarantee absolute security.
              </p>
            </CardContent>
          </Card>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicyPage;
